export const COVER_IMAGE_GROUP_UPLOAD = 'upload';
export const COVER_IMAGE_GROUP_IMAGE = 'image';
export const COVER_IMAGE_GROUP_LOGO = 'logo';
